export default function convertToDecimal(str: string, fractionDigits = 1) {
  const num = parseFloat(str);
  return Number.isInteger(num) ? num.toFixed(fractionDigits) : num;
}
